import React, { Component } from 'react';
import { Form, Alert, Modal } from 'antd';
import Redirect from 'react-router-dom/Redirect';
import { Auth, Customer } from '../../../../services/api';
import FinalizeForm from './FinalizeForm';
import TokenStorage from '../../../../services/TokenStorage';
import Storage from '../../../../services/Storage';

const WrappedForm = Form.create()(FinalizeForm);

export default class Finalize extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectToReferer: false,
            loading: false
        };

        this.authApi = new Auth(props);
        this.customerApi = new Customer(props);
    }

    finalize = (password) => {
        const data = {
            password: password,
            code: this.getQueryParam('code'),
            email: this.getQueryParam('email').replace(' ', '+')
        };

        this.setState({ loading: true });
        this.authApi.finalize(data)
            .then(res => {
                TokenStorage.setToken(TokenStorage.TYPE_ID, res.data.data.id_token);
                TokenStorage.setToken(TokenStorage.TYPE_REFRESH, res.data.data.refresh_token);
                this.fetchCustomer();
            })
            .catch(err => {
                this.setState({ loading: false });
                if (err.response && err.response.status === 400) {
                    if (err.response.data.error === 'Expired') {
                        Modal.warning({
                            title: 'Aktiveringstiden har gått ut',
                            content: 'Tiden som din aktiveringslänk är giltig har gått ut, men en ny har skickats till din e-post.',
                        });
                    } else if (err.response.data.error === 'Already finalized') {
                        Modal.warning({
                            title: 'Ditt konto är redan aktiverat',
                            content: 'Klicka på knappen nedan för att logga in.',
                            okText: 'Logga in',
                            onOk: () => this.props.history.push('/auth/login')                          
                        });
                    }
                }
            });
    }

    fetchCustomer = () => {
        this.customerApi.me()
            .then(res => {
                Storage.set('CUSTOMER', res.data.data.owner.name);
                this.setState({ redirectToReferer: true, loading: false });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.fetchCustomer });
            });
    }

    getQueryParam = (param) => {
        const query = new URLSearchParams(this.props.location.search);
        return query.get(param);
    }

    render() {
        let { from } = this.props.location.state || { from: { pathname: '/menus' } };
        const { redirectToReferer, error, loading  } = this.state;

        if (redirectToReferer === true) {
            if (!from) {
                from = { from: { pathname: '/menus' } };
            }
            return <Redirect to={from} />
        }

        return (
            <div>
                <Alert
                    style={{marginBottom: '20px'}}
                    message="Välkommen till Varma"
                    description="Innan du kan komma igång måste du skapa ett lösenord samt lägga till dina kortuppgifter."
                    type="info"
                />

                    <WrappedForm onSubmit={this.finalize} loading={loading} error={error} email={this.getQueryParam('email').replace(' ', '+')} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/register/Finalize.js